import { Search } from 'lucide-react'

type Props = {
  value:    string
  onChange: (v: string) => void
  onFocus?: () => void
}

export function HomeSearchBar({ value, onChange, onFocus }: Props) {
  return (
    <div className="mb-[14px] flex items-center gap-[10px] rounded-[14px] border border-border-sand bg-paper px-[14px] py-3">
      <Search className="h-4 w-4 text-ink-muted" strokeWidth={1.5} />
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={onFocus}
        placeholder="Search your pantry..."
        className="flex-1 bg-transparent font-serif text-[14px] italic text-ink placeholder:text-ink-muted focus:outline-none"
      />
      {value && (
        <button onClick={() => onChange('')} className="text-ink-muted text-xs">✕</button>
      )}
    </div>
  )
}
